import { Styled } from "components/Styled";
import styled from "styled-components";

export const StyledKindFuelSection = styled(Styled.Section)`
padding-bottom:0;
`